export default (fn) => {
  const cache = {};

  return (...args) => {
    const key = JSON.stringify(args);
    return cache[key] || (
      cache[key] = fn.apply(null, args)
    );
  };
}



//////////////////
// WEBPACK FOOTER
// ./src/js/miss-plete/memoize.js
// module id = 41
// module chunks = 0